import { InputComponent } from "../components/elements/input/input.component";

export enum ValidationEnum {
  NotSame = 'notSame',
  Required = 'required',
  Pattern = 'pattern',
  Email = 'email',
  MinLength = 'minLength',
  MaxLength = 'maxLength',
  StartDate = 'startdate',
  EndDate = 'enddate',
}

InputComponent
